
export enum UploadStatus {
  IDLE = 'IDLE',
  USER_INFO = 'USER_INFO',
  UPLOADING = 'UPLOADING',
  SUBMITTING = 'SUBMITTING',
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR'
}

export interface UserDetails {
  name: string;
  phone: string;
  email: string;
}

export interface QuotationFile {
  file: File;
  name: string;
  size: number;
  type: string;
}

export interface SubmissionData {
  user: UserDetails;
  fileName: string;
  timestamp: string;
}

/**
 * Interface representing the AI analysis result of a car quotation.
 */
export interface AnalysisResult {
  estimatedSavings: string;
  message: string;
  guaranteedDiscount: string;
}
